/** Decode the PocketBase numeric mini-contract without exposing raw codes. */
export function sellerTypeLabel(value) {
  if (value === null || value === undefined || value === false) return ''
  const normalized = String(value).trim().toLowerCase()
  if (!normalized || normalized === '0') return ''
  if (normalized === '1' || normalized === 'dealer') return 'Dealer'
  if (normalized === '2' || normalized === 'private' || normalized === 'particulier') {
    return 'Particulier'
  }
  // The field is an enum contract, not free text. Marketplace names and future
  // or malformed values must fail closed instead of becoming seller labels.
  return ''
}
